import React,{useContext} from 'react'
import { GlobalContext } from '../../../context/provider';
import numberbeautify from '../../../utils/numberbeautify';
import money_rounding from '../../../utils/money_rounding';

const Company_loan_table = () => {
    const { initState } = useContext(GlobalContext);
    return (
        <div className="mt-6">
            {/* Category List Card */}
            <div className="bg-white border border-slate-100 rounded-xl shadow-sm overflow-x-auto">
                
                {/* Section Header */}
                <div className="flex items-center justify-between px-6 py-4 border-b border-slate-100">
                    <h2 className="text-base font-semibold text-slate-800">لیستی قەرزی کۆمپانیا</h2>
                </div>

                {/* Table */}
                <table className="w-full">
                    <thead>
                        <tr className="bg-slate-50 border-b border-slate-100">
                            <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                                ناوی کۆمپانیا
                            </th>
                            <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                                ناونیشان
                            </th>
                            <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                                ژمارە
                            </th>
                            <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                                بڕی قەرزی ماوە
                            </th>
                        </tr>
                    </thead>
                    <tbody className="divide-y divide-slate-50">
                        {initState.company_loan_report.map((lis)=>(
                        <tr key={lis.company_id} className="hover:bg-slate-50 transition-colors duration-100">
                            <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                                {lis.company_name}
                            </td>
                            <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                                {lis.company_address}
                            </td>
                            <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                                {lis.company_phone} 
                            </td>
                            <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                                {numberbeautify(money_rounding(lis.company_loan))}
                            </td>
                        </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    )
}

export default Company_loan_table